/**
 * acad.pgp import persistence — user preference state (persisted), NOT
 * document state. Stores the RESOLVED alias → canonical mappings of the
 * last imported acad.pgp file so REINIT can re-apply them without the
 * original file, plus the legacy-registry "extras" the dispatcher resolves
 * after the CAD parser (SAVE, OPEN, ...).
 */

import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export interface AcadPgpMapping {
    alias: string;
    canonicalId: string;
}

export interface AcadPgpExtra {
    alias: string;
    legacyId: string;
}

interface AcadPgpState {
    /** Display name of the imported file (for REINIT messages). */
    fileName: string | null;
    importedAt: number | null;
    entries: AcadPgpMapping[];
    extras: AcadPgpExtra[];
    setImport: (input: { fileName: string; entries: AcadPgpMapping[]; extras: AcadPgpExtra[] }) => void;
    clear: () => void;
}

export const useAcadPgpStore = create<AcadPgpState>()(
    persist(
        (set) => ({
            fileName: null,
            importedAt: null,
            entries: [],
            extras: [],
            setImport: ({ fileName, entries, extras }) =>
                set({ fileName, importedAt: Date.now(), entries, extras }),
            clear: () => set({ fileName: null, importedAt: null, entries: [], extras: [] }),
        }),
        { name: 'yap-acad-pgp' }
    )
);
